import axios from "axios";
import {
  GET_USERS_DEPARTMENT_FAIL,
  GET_USERS_DEPARTMENT_REQUEST,
  GET_USERS_DEPARTMENT_SUCCESS,
} from "../../types/user/departTypes";

export const getDepartments = (companyId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_USERS_DEPARTMENT_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `${sharedUserInfo?.payload?.token}`,
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/user/company/${companyId}/department/all`,
      config
    );
    dispatch({
      type: GET_USERS_DEPARTMENT_SUCCESS,
      payload: data?.data,
    });
    // console.log(data?.data)
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: GET_USERS_DEPARTMENT_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
